<script setup lang="ts">
import { inject, onMounted }          from "vue";
import { MainCarousel }               from "@TsUtils/MainCarousel";
import type { TypePartnersDataItems } from "@ViewPages/Main/Components/commonTypes";

type TypeProps = {
    partners_data : TypePartnersDataItems,
    device_type : string,
};

const props = <TypeProps>inject('partners_data'),
    isMobileDevice = props?.device_type == 'mobile';

const mainCarousel = new MainCarousel({
    idOrClassNameCarouseEl: '#partners-items-carousel',
    idOrClassNameCarouselItemsEls: '#partners-items-carousel-item-',
    idOrClassNameIndicatorEls: '#partners-items-carousel-indicator-',
    data_list: props?.partners_data.partners_list,
    isMobileDevice: isMobileDevice,
});

onMounted(() => {
    if (isMobileDevice) {
        mainCarousel.handleCarousel();
    }
});

const carouselItemClass = [
        isMobileDevice
            ? 'hidden duration-200 ease-linear'
            : 'w-14%',
        'flex items-center justify-center min-w-24',
    ].join(' '),
    carouselWrapperClass = [
        isMobileDevice ? 'h-56' : 'flex flex-wrap justify-evenly gap-4 xl:gap-x-4 xl:gap-y-10'
    ].join(' ');
</script>

<template>
    <div class="reviews__item">
        <div class="relative w-full overflow-hidden" id="partners-items-carousel">
            <!-- Carousel wrapper -->
            <div :class="carouselWrapperClass">
                <!-- Item -->
                <div v-for="(data, index) in props?.partners_data.partners_list"
                     :key="index" :id="'partners-items-carousel-item-' + (+index + 1)"
                     :class="[carouselItemClass]"
                     @touchstart="mainCarousel.handleTouchStart"
                     @touchend="mainCarousel.handleTouchEnd"
                     @touchmove="mainCarousel.handleTouchMove">

                    <div v-html="data.img_tag"></div>
                </div>
            </div>

            <!-- Slider indicators -->
            <div v-if="isMobileDevice"
                 class="absolute z-30 flex -translate-x-1/2 space-x-3 bottom-3 left-1/2">
                <button type="button" class="w-3 h-3 rounded-full" v-for="index in Object.keys(props?.partners_data.partners_list)"
                        :aria-current="+index == 0"
                        :aria-label="'Slide' + index"
                        :id="'partners-items-carousel-indicator-' + (+index + 1)"
                ></button>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
